import { createSelector } from 'reselect';

const getState = (state) => state.shipperOrderNew;

const isModalOpened = createSelector(getState, (state) => state.opened);
const getCurrentShipperOrder = createSelector(getState, (state) => state.currentShipperOrder);
const getCurrentAddresses = createSelector(getState, (state) =>
  state.opened ? state.currentAddresses : []
);
const getRecentlyCreatedShipperOrder = createSelector(
  getState,
  (state) => state.recentlyCreatedShipperOrder
);
const getIsSavingCost = createSelector(getState, (state) => state.savingCost);

const getCheckTimes = createSelector(getState, (state) => state.checkTimes);

const getTimeWarning = createSelector(getState, (state) => state.timeWarning);

const getShipperWarning = createSelector(getState, (state) => state.shipperWarning);

export {
  isModalOpened,
  getCurrentShipperOrder,
  getRecentlyCreatedShipperOrder,
  getCurrentAddresses,
  getIsSavingCost,
  getCheckTimes,
  getTimeWarning,
  getShipperWarning,
};
